import { serializePersonsToMap } from './person';
import { serializeAttachmentsToMap } from './attachment';
import { MESSAGE_TYPES } from '../../consts/chains';
import { getSafeMessageBody } from '../sagas/utils';

export const concatServiceMessages = (concated, current) => {
  const prev = concated[concated.length - 1];
  const { message, client } = { ...current };

  if (message.type === MESSAGE_TYPES.SERVICE_MENU) {
    if (prev && prev.message.type === MESSAGE_TYPES.SERVICE_GROUP) {
      prev.message.groupedMessages.push(current);
      return concated;
    }

    return [
      ...concated,
      {
        message: {
          ...message,
          type: MESSAGE_TYPES.SERVICE_GROUP,
          groupedMessages: [...message.groupedMessages, current],
        },
        client,
      },
    ];
  }

  return [...concated, current];
};

export const serializeMessage = (message, persons, attachments) => {
  const serializedPersons = serializePersonsToMap(persons) || {};
  const serializedAttachments = serializeAttachmentsToMap(attachments) || {};
  const personId = message.is_incoming ? message.person_id : message.manager_id;

  return {
    client: (personId && serializedPersons[personId]) || undefined,
    message: {
      id: message.id.toString(),
      chainId: message.chain_id && message.chain_id.toString(),
      attachments:
        (message.attachment_ids &&
          message.attachment_ids.length > 0 &&
          message.attachment_ids.map(id => serializedAttachments[id])) ||
        null,
      text: getSafeMessageBody(message.content),
      isAuto: message.is_auto,
      isDelivered: message.is_delivered,
      isIncoming: message.is_incoming,
      isRead: message.is_read,
      time: message.created_at,
      personType: message.person_type,
      currentManagerName: message.current_manager_name,
      extra: message.extra,
      type: message.kind,
      groupedMessages: [],
    },
  };
};

export const serializeMessages = (messages, persons, attachments) => {
  if (!messages || messages.length <= 0) return [];

  return messages
    .map(ms => serializeMessage(ms, persons, attachments))
    .reduce(concatServiceMessages, []);
};

export const serializeExcessTicketMessages = messages =>
  serializeMessages(messages || [], [], []).map(({ client, message }) => ({
    client: client || {
      fullName: message.isIncoming
        ? messages.find(({ id }) => String(id) === message.id)?.full_name
        : message.currentManagerName,
    },
    message: {
      ...message,
      isHistory: true,
    },
  }));

export const sortMessages = messages => {
  if (!messages && messages.length <= 0) return null;

  // return messages.sort((a, b) => Number(a.message.id) - Number(b.message.id));
  return messages.sort((a, b) => a.message.time - b.message.time);
};

export const serializeSearchMessage = message => {
  const time = new Date(message.created_at);
  return {
    ticketId: message.ticket_id,
    chainId: message.chain_id,
    message: message.message,
    subject: message.content,
    type: 'message',
    name: message.full_name,
    isIncoming: message.is_incoming,
    time,
  };
};
